import { Button, Hint } from '@routable/components';
import React from 'react';
export const CantValidateRiskChecksHint = ({ onContactSupport }) => {
    return (React.createElement(Hint, { title: "Something went wrong during the validation process", type: "critical", variant: "outline" },
        React.createElement("div", { className: "flex flex-col gap-5" },
            React.createElement("span", null, "Please contact support to resolve this issue."),
            React.createElement(Button, { "data-testid": "cant-validate-contact-support", variant: "outline", onPress: onContactSupport }, "Contact support"))));
};
